import React from 'react';
import { Logger } from 'aws-amplify';
import { NotificationBadge } from 'src/components/NotificationBadge';
import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';
import {
  FormCompleteNotification,
  FormRequestNotification,
} from 'src/store/notifications/types';
import { FlagsContext } from 'src/context';
import { useAppSelector } from 'src/hooks/useStore';
import { createSelector } from '@reduxjs/toolkit';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';

const logger = new Logger('FormsNotificationsBadge');

const selectFormRequestNotifications = createSelector(
  (state: RootState) => state.notifications.formRequestNotifications,
  (state: RootState) => state.activeCompany.activeCompanyId,
  (_: RootState, EnableManyCompanies: boolean) => EnableManyCompanies,
  (formRequestNotifications, activeCompanyId, EnableManyCompanies) =>
    formRequestNotifications.filter((notif) =>
      EnableManyCompanies ? notif.companyId === activeCompanyId : true,
    ) || [],
);

// FormsNotificationsBadge notifications for forms events
export const FormsNotificationsBadge = () => {
  const { EnableManyCompanies } = React.useContext(FlagsContext);
  const { backgroundColor, textColor } = useNotificationBadgeData(true);
  const isClient = useAppSelector((state: RootState) => state.user.isClient);

  const completedFormNotifs =
    useAppSelector(
      (state: RootState) => state.notifications.formCompletedNotifications,
    ) || [];
  const requestFormNotifs = useAppSelector((state) =>
    selectFormRequestNotifications(state, EnableManyCompanies),
  );

  // Get the notifications from the store according to the user role
  const notifications: FormCompleteNotification[] | FormRequestNotification[] =
    !isClient ? completedFormNotifs : requestFormNotifs;

  const [notificationsCounter, setNotificationsCounter] = React.useState(0);

  React.useEffect(() => {
    logger.debug('Setting primary forms sidebar notification');
    // filter unread notification
    logger.debug('Total notifications:', notifications.length);
    const unreadNotifications = notifications.filter((notif) =>
      isUnreadNotification(notif),
    );

    logger.debug('Unread notifications:', unreadNotifications.length);

    setNotificationsCounter(unreadNotifications.length);
  }, [notifications]);

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={notificationsCounter}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
